import { Mail, Clock, Building2 } from "lucide-react";
import { usePageMeta } from "@/lib/usePageMeta";
import { SITE } from "@/lib/site";
import { useLang } from "@/lib/i18n";
import { PageIntro, Reveal } from "@/components/Reveal";

export default function Contact() {
  const { t } = useLang();
  const c = t.contact;
  usePageMeta(c.meta);

  return (
    <>
      <PageIntro eyebrow={c.eyebrow} title={c.title} subtitle={c.subtitle} testId="contact-intro" />

      <section data-testid="contact-section">
        <div className="container-x py-20 sm:py-28">
          <div className="grid gap-px overflow-hidden rounded-2xl border border-line bg-line md:grid-cols-3">
            <Reveal className="bg-white p-8 sm:p-10" data-testid="contact-company">
              <Building2 size={20} strokeWidth={1.75} className="text-coral" />
              <p className="eyebrow mt-8">{c.companyLabel}</p>
              <p className="mt-2 text-lg font-bold tracking-tight text-navy">{SITE.name}</p>
              <address className="mt-1 text-sm not-italic leading-relaxed text-muted" data-testid="contact-address">
                {SITE.address.slice(1).map((line) => (
                  <span key={line} className="block">{line}</span>
                ))}
              </address>
            </Reveal>

            <Reveal delay={0.1} className="bg-white p-8 sm:p-10" data-testid="contact-email-block">
              <Mail size={20} strokeWidth={1.75} className="text-coral" />
              <p className="eyebrow mt-8">{c.emailLabel}</p>
              <a
                href={`mailto:${SITE.email}`}
                className="link-underline mt-2 inline-block break-all text-lg font-bold tracking-tight text-brand hover:text-brand-hover"
                data-testid="contact-email"
              >
                {SITE.email}
              </a>
            </Reveal>

            <Reveal delay={0.2} className="bg-white p-8 sm:p-10" data-testid="contact-response">
              <Clock size={20} strokeWidth={1.75} className="text-coral" />
              <p className="eyebrow mt-8">{c.responseLabel}</p>
              <p className="mt-2 text-lg font-bold tracking-tight text-navy" data-testid="contact-response-time">
                {c.responseTime}
              </p>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
